/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { entitiesListInstructions } from "../../funcs/entitiesListInstructions.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$entitiesListInstructions: ToolDefinition = {
  name: "entities-list-instructions",
  description: `List Instructions

List all instructions.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await entitiesListInstructions(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
